<div class="mb-4" *ngIf="breadcrumbsList && breadcrumbsList.length > 0">
    <small>
        <a [routerLink]="[ '/catalog',1]" class="main-color" routerLinkActive="active"><i class="fa fa-lg fa-home"></i></a>
        <span class="fa fa-long-arrow-right main-color p-2"> </span>
        <span *ngFor="let breadcrumb of breadcrumbsList; let i = index">
            <a [routerLink]="[ '/catalog',breadcrumb.id]" class="main-color"
                routerLinkActive="active">{{breadcrumb.title}}</a>
            <span class="fa fa-long-arrow-right main-color p-2" *ngIf="i < breadcrumbsList.length-1"> </span>
        </span>
    </small>
</div>